import { render, staticRenderFns } from "./clubDetails.vue?vue&type=template&id=41813ad4&"
import script from "./clubDetails.vue?vue&type=script&lang=js&"
export * from "./clubDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports